var map = {
	"./course-app-calculator/Settings.jsx": [
		35952,
		952
	],
	"./course-app-edxnotes/Settings.jsx": [
		42248,
		248
	],
	"./course-app-learning_assistant/Settings.jsx": [
		71463,
		463
	],
	"./course-app-live/Settings.jsx": [
		47124,
		143,
		124
	],
	"./course-app-ora_settings/Settings.jsx": [
		37708,
		708
	],
	"./course-app-proctoring/Settings.jsx": [
		31115,
		115
	],
	"./course-app-progress/Settings.jsx": [
		45009,
		9
	],
	"./course-app-teams/Settings.jsx": [
		21071,
		71
	],
	"./course-app-wiki/Settings.jsx": [
		55116,
		116
	],
	"./course-app-xpert_unit_summary/Settings.jsx": [
		67489,
		489
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 58010;
module.exports = webpackAsyncContext;